/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 */
/// ///////////////////////////////////////////////////////////////////////////
// Feedback forms are links which take users to a short survey (1 simple
// question) were they can write freeform thoughts which are sent to us
// (via Slack)
/// ///////////////////////////////////////////////////////////////////////////

import { User } from '../types';

// We use Typeform for its simple experience and clean UI. It also has
// nice integration with Slack channels. More info about billing can be
// found in Confluence:
// https://ouster.atlassian.net/wiki/spaces/SW/pages/1775697933/3rd+party+software
const TYPEFORM_BASE_LINK = 'https://form.typeform.com/to/XfXOrUKH';

type HiddenFieldValues = Record<string, string | number | boolean | undefined>;

const typeformLinkFromUser = (
  user?: User,
  pathName?: string,
  hiddenFields?: HiddenFieldValues
) => {
  const hidden = {
    name: user?.name ?? '',
    email: user?.email ?? '',
    from: pathName ?? '',
    ...hiddenFields,
  };

  const urlFragment = new URLSearchParams(
    Object.entries(hidden).reduce<Record<string, string>>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = String(value);
        }
        return acc;
      },
      {}
    )
  ).toString();

  const link = `${TYPEFORM_BASE_LINK}#${urlFragment}`;
  return encodeURI(link);
};

export { typeformLinkFromUser };
